module.exports = __webpack_public_path__ + "img/10t.prt.908ea18a.jpg";